const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStarFeedback(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "star_feedback_svg__dr",
    xmlns: "http://www.w3.org/2000/svg",
    width: 430,
    height: 430,
    viewBox: "0 0 430 430",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m215,96.74l34.52,69.95,5.58,11.31,12.49,1.81,77.2,11.22-55.86,54.45-9.04,8.81,2.13,12.44,13.19,76.88-69.05-36.3-11.17-5.87-11.17,5.87-69.05,36.3,13.19-76.88,2.13-12.44-9.04-8.81-55.86-54.45,77.2-11.22,12.49-1.81,5.58-11.31,34.52-69.95m0-54.23l-56.05,113.56-125.32,18.21,90.68,88.39-21.41,124.81,112.09-58.93,112.09,58.93-21.41-124.81,90.68-88.39-125.32-18.21-56.05-113.56h0Z",
    style: {
      fill: "#f7f7f7"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarFeedback);
export default __webpack_public_path__ + "static/media/star_feedback.e4ff1b60a1dae4b8ecf1ebec01162f1a.svg";
export { ForwardRef as ReactComponent };